// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"bba18c0e3c329831599e","293":"999ca3d23e399578952b","518":"fbaa4838196c5b9bfce8","779":"0fdec6c30e60d97fffc1"}[chunkId] + ".js";
};